//请自行添加语言资源
const diamondReportForm = {
  customerCode:'客户代码',
  packer: 'Packer代码',
  fileName:'附件标题',
  statusName: '对接状态',
  status: '对接状态',
  result: '对接信息',
  createTime: '上传时间',
  creator: '上传用户',
  remark: '备注',
};
export default diamondReportForm



// WEBPACK FOOTER //
// ./src/page/report/diamondReportForm/lang/diamondReportForm.zh.js